import React from 'react'
import PropTypes from 'prop-types'
import { INBOUND_TYPE } from 'domains/merchant-inbound/constants'
import StatusBadge from 'components/atoms/status-badge'


const propTypes = {
  inbound_type: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Inbound `INBOUND_TYPE`.
 * It maps `INBOUND_TYPE` to certain style and pass to `StatusBadge`.
 * @param {string} inbound_type. available values
 * - `pickup`
 * - `dropoff`
 * - `listing`
 */
const MerchantInboundTypeBadge = ({ inbound_type }) => {

  const colorMap = {
    [INBOUND_TYPE.PICKUP]  : 'primary',
    [INBOUND_TYPE.DROPOFF] : 'info',
    [INBOUND_TYPE.LISTING] : 'success'
  }

  const color = colorMap[inbound_type] || 'default'

  return <StatusBadge color={ color } label={ inbound_type } />
}

MerchantInboundTypeBadge.propTypes = propTypes

export default MerchantInboundTypeBadge